// frontend/src/components/common/UI/Card.tsx

import React from 'react'
import { cn } from '@/utils/helpers'

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export const Card: React.FC<CardProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div
      className={cn(
        'bg-white rounded-lg shadow-sm border border-secondary-200',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}